<template>
  <div class="custom-checkbox" @click="handleClick()">
    <div class="check">
      <img :style="{opacity: (!value ? '0' : '1'),}" :src="imgCheck" />
    </div>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
import imgCheck from '../../assets/new/checkbox-icon.svg'

export default {
  name: 'CCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imgCheck,
      value: this.checked,
    }
  },
  watch: {
    checked() {
      this.value = this.checked
    },
  },
  methods: {
    handleClick() {
      if (!this.text) {
        this.value = !this.value
        this.$emit('update:value', this.value)
        this.$emit('update:checked', this.value)
        this.$emit('change', this.value)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.custom-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;

  .check {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border: 2px solid var(--primary);
    border-radius: 2px;
    transition: all 0.15s ease-in-out;
    img {
      transition: all 0.15s ease-in-out;
    }
  }

  .title {
    margin-left: 8px;
  }
}
</style>
